import { ChatIcon } from './Sparkle';

/** The floating bubble that opens the panel. Only used by layout="floating" —
 * layout="panel" (the portal) has its own Metronic-styled launcher button and
 * never renders this. A chat-bubble icon (not the AI sparkle used elsewhere)
 * so it reads as "click me to chat" on sight, with no label to go by. */
export function Launcher({ onClick }: { onClick: () => void }) {
  return (
    <button
      type="button"
      class="aj-launcher"
      title="Ask Jumino"
      aria-label="Open Ask Jumino chat"
      onClick={onClick}
    >
      <ChatIcon />
    </button>
  );
}
